import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import ResponsiveTable from 'components/common/responsive-table/ResponsiveTable';
import withRedirectToOutsideApp from 'components/common/with-redirect-to-outside-app/withRedirectToOutsideApp';
import { SORT_DIRECTION } from 'constants/app.constant';
import { appSelectors } from 'redux/ducks/app';
import { triggerSortTableManually } from 'services/table.service';
import { ASSIGNMENT_ENGAGEMENT_TABLE_SELECTORS, ASSIGNMENT_TYPE_GROUPS, getAssignmentTypeById } from 'reports/cw/constants/report.constant';
import { getIsOsmosisAssignment } from 'reports/cw/helpers/report.helper';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { cwSelectors } from 'reports/cw/redux/ducks/cw';
import { compareDate, renderClassAvgGrade, renderClassAvgTimeSpent, renderDueDate, renderName, renderPercentCompletion, renderScoringType } from '../assignment-engagement-table-helper/AssignmentEngagementTableHelper';
var AssignmentEngagementTable = function (_a) {
    var _b;
    var tableData = _a.tableData, featureFlags = _a.featureFlags, assignmentTypeId = _a.assignmentTypeId, searchKeyword = _a.searchKeyword, xLinkId = _a.xLinkId, isBackToPreviousAppIconShown = _a.isBackToPreviousAppIconShown, assignmentEngagementCardAndTableSortInteraction = _a.assignmentEngagementCardAndTableSortInteraction, onRedirectToOutsideApp = _a.onRedirectToOutsideApp, courseId = _a.courseId, courseSectionInfo = _a.courseSectionInfo, catalog = _a.catalog, assignments = _a.assignments;
    var interactionWithCard = useCallback(function () {
        if (assignmentEngagementCardAndTableSortInteraction) {
            triggerSortTableManually(assignmentEngagementCardAndTableSortInteraction.sortDirection, ".".concat(assignmentEngagementCardAndTableSortInteraction.columnHeaderSelector));
        }
    }, [assignmentEngagementCardAndTableSortInteraction]);
    useEffect(function () {
        interactionWithCard();
    }, [assignmentEngagementCardAndTableSortInteraction, interactionWithCard]);
    var renderAssignmentName = function (row) {
        return renderName({
            row: row,
            featureFlags: featureFlags,
            courseId: courseId,
            xLinkId: xLinkId,
            isBackToPreviousAppIconShown: isBackToPreviousAppIconShown,
            searchKeyword: searchKeyword,
            assignmentTypeId: assignmentTypeId,
            onRedirectToOutsideApp: onRedirectToOutsideApp,
            courseSectionInfo: courseSectionInfo,
            catalog: catalog,
            assignments: assignments
        });
    };
    var isEAQAssignmentType = ((_b = getAssignmentTypeById(assignmentTypeId)) === null || _b === void 0 ? void 0 : _b.group) === ASSIGNMENT_TYPE_GROUPS.EAQ;
    var isOsmosisAssignmentType = getIsOsmosisAssignment(assignmentTypeId);
    var columns = [
        {
            field: 'name',
            header: 'Assignments',
            customRender: renderAssignmentName,
            minWidth: 300
        },
        {
            field: 'percentCompletion',
            header: 'Completion',
            headerCssModifier: ASSIGNMENT_ENGAGEMENT_TABLE_SELECTORS.completionColumn,
            customRender: renderPercentCompletion
        },
        {
            field: 'scoringType',
            header: 'Scoring Type',
            customRender: renderScoringType
        },
        {
            field: 'classAvgScore',
            header: 'Class Avg Score',
            customRender: renderClassAvgGrade,
            sortNARecordInBottom: true
        }
    ];
    if (isEAQAssignmentType) {
        columns.push({
            field: 'numberOfAvgQuestionAttempt',
            header: 'Avg # Questions Attempted'
        });
    }
    if (!isOsmosisAssignmentType) {
        columns.push({
            field: 'classAvgTimeSpentSeconds',
            header: isEAQAssignmentType ? 'Class Avg Time Spent per Question' : 'Class Avg Time Spent',
            customRender: renderClassAvgTimeSpent
        });
    }
    columns.push({
        field: 'dueDate',
        header: 'Due Date',
        customSort: compareDate,
        customRender: renderDueDate
    });
    var tableProps = {
        cssModifier: 'c-cw-assignment-engagement-table',
        defaultSortField: 'classAvgScore',
        defaultSortDirection: SORT_DIRECTION.ASC
    };
    return <ResponsiveTable columns={columns} records={tableData} tableProps={tableProps}/>;
};
var mapStateToProps = function (state) { return ({
    assignmentEngagementCardAndTableSortInteraction: cwSelectors.getAssignmentEngagementCardAndTableSortInteraction(state),
    courseId: appSelectors.getSelectedCourse(state),
    featureFlags: appSelectors.getFeatureFlags(state),
    xLinkId: appSelectors.getLinkId(state),
    courseSectionInfo: courseSelectors.getCourseSectionInfo(state),
    catalog: appSelectors.getCatalog(state),
    assignments: appSelectors.getAssignments(state)
}); };
var enhancers = [connect(mapStateToProps), withRedirectToOutsideApp];
export { AssignmentEngagementTable as AssignmentEngagementTableBase };
export default compose.apply(void 0, enhancers)(AssignmentEngagementTable);
